module.exports = __webpack_public_path__ + "05a045830800a614fca17eeba4679010.pdf";